// extracted by mini-css-extract-plugin
module.exports = {"bgimg":"SignUp_bgimg__mstNB","content":"SignUp_content__gzJll","field":"SignUp_field__21nQh","signup":"SignUp_signup__2PH9L","regester":"SignUp_regester__XTVjE"};